import { QueryParams, TAG_TYPES } from 'types';
import { baseApi } from './index';
import { Supplier as T } from 'models';
import { getQueryParams } from 'utils';
import { SupplierFormValues } from 'models/Supplier';

const urlEndpoint = `${process.env.REACT_APP_BASE_URL}/suppliers`;
const tagType = TAG_TYPES.Supplier;
const SupplierApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllSuppliers: builder.query<
      {
        data: {
          rows: T[];
          count: number;
        };
        success: boolean;
      },
      { query: QueryParams }
    >({
      query: (params) => {
        const query = getQueryParams(params?.query);
        if (query === '') return { url: urlEndpoint, method: 'GET' };
        return {
          url: `${urlEndpoint}?${query}`,
          method: 'GET',
        };
      },
      providesTags: (result) => {
        return result
          ? [...(result?.data.rows || []).map(({ id }) => ({ type: tagType, id })), { type: tagType, id: 'LIST' }]
          : [{ type: tagType, id: 'LIST' }];
      },
    }),
    getByIdSupplier: builder.query<{ success: boolean; data: T }, { id: string; query?: QueryParams }>({
      query: ({ id, query }) => {
        const queryString = query ? `?${getQueryParams(query)}` : '';

        return {
          url: `${urlEndpoint}/${id}${queryString}`,
          method: 'GET',
        };
      },
      providesTags: (result, error, { id }) => [{ type: tagType, id }],
    }),

    createSupplier: builder.mutation<{ success: boolean; data: T }, SupplierFormValues>({
      query: (data) => ({
        url: urlEndpoint,
        method: 'POST',
        data,
      }),
      invalidatesTags: [{ type: tagType, id: 'LIST' }],
    }),

    updateSupplier: builder.mutation<{ success: boolean; data: T }, { id: string; body: SupplierFormValues }>({
      query: ({ id, body }) => ({
        url: `${urlEndpoint}/${id}`,
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: tagType, id }],
    }),
     deleteSupplier: builder.mutation<{ success: boolean; data: T }, string>({
      query: (id) => ({
        url: `${urlEndpoint}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: tagType, id },
        { type: tagType, id: 'LIST' },
      ],
    }),
  }),
});
export const {
  useGetAllSuppliersQuery: useGetSuppliersQuery,
  useGetByIdSupplierQuery: useGetSupplierByIdQuery,
  useCreateSupplierMutation: useCreateSupplierMutation,
  useUpdateSupplierMutation: useUpdateSupplierMutation,
  useDeleteSupplierMutation: useDeleteSupplierMutation, 
  useLazyGetAllSuppliersQuery,
  useLazyGetByIdSupplierQuery,
} = SupplierApiService;
